import { gsap } from "../../../../npm/node_modules/gsap";
import { ScrollTrigger } from "../../../../npm/node_modules/gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


(function () {

  const bullets = document.querySelectorAll('.image-bullet-list li');

  bullets.forEach((bullet, index) => {


    if (index % 2 === 0) {

      gsap.to(bullet.querySelector('.image-side'), {
        scrollTrigger: {
          trigger: bullet,
          start: "top center",


        },
        left: 0,
      });

      gsap.to(bullet.querySelector('.content'), {
        scrollTrigger: {
          trigger: bullet,
          start: "top center",


        },
        right: 0,
      });

    } else {

      gsap.to(bullet.querySelector('.image-side'), {
        scrollTrigger: {
          trigger: bullet,
          start: "top center",
          // markers: true

        },
        right: 0,
      });

      gsap.to(bullet.querySelector('.content'), {
        scrollTrigger: {
          trigger: bullet,
          start: "top center",
          // markers: true

        },
        left: 0,
      });



    }

  })


}())